import type { QueryClient } from '@tanstack/react-query'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'

import { Devtools } from '@/components/devtools'
import { RouteErrorBoundary, RouteNotFound } from '@/components/layout/route-error'
import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'

/** 路由上下文:loader / beforeLoad 里直接拿 queryClient,免得到处 import 单例。 */
export interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  errorComponent: RouteErrorBoundary,
  notFoundComponent: RouteNotFound,
})

function RootLayout() {
  return (
    <TooltipProvider>
      <Outlet />
      <Toaster />
      <Devtools />
    </TooltipProvider>
  )
}
